import { useEffect } from 'react';
import { listenTheme } from '../../channels/themeChannel';
import { useThemeModeStore } from '../../stores/useThemeModeStore';

export function useThemeChannel() {

    useEffect(() => {

        return listenTheme(({ mode }) => {
            useThemeModeStore
                .getState()
                .setMode(mode, false);
        });

    }, []);

}